/**
 * @author Rohman Widiyanto
 * @email rohmansca@gmail.com
 * @create date 2022-04-04 06:08:29
 * @modify date 2022-04-04 06:08:29
 */

import React from 'react'
import { Link } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { Button, Stack } from '@mui/material'

import { useStores } from 'models'
import { ModalWrapper } from 'components'
import { COMPLAIN_EMAIL_ADDRESS } from 'config/env'

import { En } from './components/en'

export const Privacy: React.FC = observer(() => {
  const { t } = useTranslation()
  const { modalStore: { privacy, setValue }} = useStores()

  const openMail = (
    <a href={`mailto:${COMPLAIN_EMAIL_ADDRESS}`}>{COMPLAIN_EMAIL_ADDRESS}</a>
  )

  const openTermsOfUse = (
    <Link
      to='#'
      onClick={() => {
        setValue('privacy', false)
        setValue('termsOfUse', true)
      }}
    >
      {t('menu.termsOfUse')}
    </Link>
  )

  const attributes = {
    openMail: openMail,
    openTermsOfUse: openTermsOfUse
  }

  const languageComponent = () => {
    return <En {...attributes} />
  }
  
  return (
    <ModalWrapper
      maxWidth='md'
      open={privacy}
      onClose={() => setValue('privacy', false)}
    >
      {languageComponent()}

      <Stack direction="row" justifyContent="center">
        <Button variant='contained' className='wide' onClick={() => setValue('privacy', false)}>
          {t('common.close')}
        </Button>
      </Stack>
    </ModalWrapper>
  )
})